import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconCheckCircle = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 21 20" fill="none">
    <circle
      cx="10.5001"
      cy="10"
      r="8.33333"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
    />
    <path
      d="M7.58325 10.4167L9.24992 12.0834L13.4166 7.91669"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
